import React from 'react'
import LayoutContainer from '../../Components/LayoutContainer/LayoutContainer'
import { SavePageNumberOfSuperyProducts } from '../../Utils/Context/SavePageNumberOfSuperyProducts'

const Layout = ({children}) => {
  return (
    <div className="pageHolder">
      <SavePageNumberOfSuperyProducts>
      <LayoutContainer children={children}/>
      </SavePageNumberOfSuperyProducts>
    </div>
  )
}

export default Layout